import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';

import withAuth from '../Components/withAuth';
import { MAP } from '../Constants/Routes';
import IconsContext from '../Context/IconsContext';
import { MAIN_HEIGHT, MOBILE_MAIN_HEIGHT } from '../Styles/constants';

export function NotFound(props) {
  const { history } = props;
  const { errorPageIcon } = useContext(IconsContext);
  return (
    <Container fluid={true}>
      <div className="not-found-container row bg-background-gray ">
        <div className="not-found-inner-container bg-white m-2 m-md-4 d-flex flex-column justify-content-center align-items-center">
          <img
            className="not-found-icon my-n5"
            src={errorPageIcon}
            alt="Page Not Found"
          />
          <span className="text-gray text-center mt-n5">
            {`we can't seem to find the page you're looking for`}
          </span>
          <div className="button-container d-flex justify-content-around mt-5">
            <button
              className="btn modal-button-primary px-md-5"
              onClick={() => {
                history.push(MAP);
              }}
            >
              go home
            </button>
            <button
              className="btn btn-outline-secondary text-gray ml-4 px-md-5 back-button"
              onClick={() => {
                history.goBack();
              }}
            >
              back
            </button>
          </div>
        </div>
      </div>
      <style jsx>{`
        .not-found-container {
          height: ${MOBILE_MAIN_HEIGHT};
        }
        .not-found-inner-container {
          width: calc(100% - 1rem);
          border-radius: 0.5rem;
        }
        .not-found-icon {
          transform: scale(0.3);
        }
        .button-container {
          width: 100%;
        }
        .text-gray {
          color: var(--text-light-gray);
        }
        .back-button:hover {
          color: white;
        }
        @media (min-width: 768px) {
          .not-found-inner-container {
            width: calc(100% - 3rem);
          }
          .not-found-icon {
            transform: scale(0.5);
          }
          .button-container {
            width: 30%;
          }
        }
        @media (min-width: 992px) {
          .not-found-container {
            height: ${MAIN_HEIGHT};
          }
        }
      `}</style>
    </Container>
  );
}
export default withAuth(NotFound);

NotFound.propTypes = {
  history: PropTypes.object,
  width: PropTypes.number,
};
